/*
These functions make sure WordPress
and Foundation play nice together.
*/
(function($) {
	$(document).ready(function() {
	var $win = $(window),
		$body = $('body');


	// Remove empty P tags created by WP inside of Accordion and Orbit
	$('.accordion p:empty, .orbit p:empty').remove();

	// Adds Flex Video to YouTube and Vimeo Embeds
	$('iframe[src*="youtube.com"], iframe[src*="vimeo.com"]').each(function() {
		if ( $(this).innerWidth() / $(this).innerHeight() > 1.5 ) {
		  $(this).wrap("<div class='widescreen responsive-embed'/>");
		} else {
		  $(this).wrap("<div class='responsive-embed'/>");
		}
	});
	$(window).on('load', function() {

		$('#ae-cform-input-reg-email-1').attr('placeholder', 'Email Address');

		// $('.js-placeholder').trigger('click');

		if( $body.hasClass('home') ) {
			$('.js-subscribe a').on('click', function(e) {
				e.preventDefault();
	
				var $target = $(this).attr('href');
		
				$('html, body').animate({
					scrollTop: $($target).offset().top
				}, 800);
	
				if ( $(this).parents('.off-canvas') ) {
					$('.js-off-canvas-overlay').trigger('click');
				}
			});
		} else {
			$('.js-subscribe a').fancybox();
		}

		if( $body.hasClass('home') ) {
			var $banner = $('.js-banner'),
				$videos = $('.js-video-list'),
				$prev = '<a href="#" class="prev pos-rel"><svg width="42" height="21" viewBox="0 0 42 21" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M15.1641 10.9502V0.950195L0.164062 10.9502L15.1641 20.9502V11.9502L41.1641 11.9502V10.9502L15.1641 10.9502Z" fill="#E0C89F"/></svg></a>',
				$next = '<a href="#" class="next pos-rel"><svg width="42" height="21" viewBox="0 0 42 21" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M26.1641 10.9502V0.950195L41.1641 10.9502L26.1641 20.9502V11.9502L0.164062 11.9502V10.9502L26.1641 10.9502Z" fill="#E0C89F"/></svg></a>';
			
			setTimeout(function(){
				$('.banner-item_content').addClass('show');
			}, 2000);

			$banner.slick({
				slidesToShow: 1,
				slidesToScroll: 1,
				dots: false,
				prevArrow: $prev,
				nextArrow: $next,
				responsive: [
				  {
					breakpoint: 815,
					settings: {
						arrows: false
					}
				  }
				]
			});

            $banner.on('beforeChange', function(event, slick, currentSlide, nextSlide){
              $banner.addClass('is-sliding');
			  $('.banner-item_content').removeClass('show');
            });
      
            $banner.on('afterChange', function(event, slick, currentSlide){
              $banner.removeClass('is-sliding');
			  $('.banner-item_content').addClass('show');
            });

			$('.js-news-list').slick({
				slidesToShow: 3,
				slidesToScroll: 3,
				responsive: [
				  {
					breakpoint: 480,
					settings: {
					  slidesToShow: 1,
					  slidesToScroll: 1
					}
				  }
				]
			});
			
			$('.js-story-list').slick({
				slidesToShow: 1,
				slidesToScroll: 1,
				centerMode: true,
				centerPadding: 0,
				dots: false,
				prevArrow: $prev,
				nextArrow: $next,
				appendArrows: $('.js-sto-sf'),
				responsive: [
				  {
					breakpoint: 480,
					settings: "unslick",
				  }
				]
			});

			$('.js-release-list').slick({
				slidesToShow: 3,
				slidesToScroll: 3,
				dots: false,
				prevArrow: $prev,
				nextArrow: $next,
				appendArrows: $('.js-rel-sf'),
				responsive: [
				  {
					breakpoint: 480,
					settings: {
						slidesToShow: 1,
						slidesToScroll: 1,
					}
				  }
				]
			});

			$videos.slick({
				slidesToShow: 1,
				slidesToScroll: 1,
				centerMode: true,
				centerPadding: 0,
				dots: false,
				prevArrow: $prev,
				nextArrow: $next,
				appendArrows: $('.js-vid-sf'),
				responsive: [
				  {
					breakpoint: 480,
					settings: "unslick",
				  }
				]
			});

            
			$('.main-home .section').each(function(){
				var self = $(this);
			
				$(this).waypoint({
					handler: function(direction) {

						if( self.hasClass('section-music') ) {
						}

						if( self.hasClass('section-videos') ) {
						}

						// if(direction == 'down') {
						// }

						// $('.main-home .section').removeClass('show');
						self.addClass('pop');
					}, offset: '50%'
				});
			});
		}
	});
});
})(jQuery);